import FetchFactory from '../factory'

interface IDetail {
  params: {
    id: number
  }
}

interface IStore {
  body: {
    name: string
    email: string
    role: string
    password: string
    password_confirmation: string
  }
}

interface IUpdate {
  params: {
    id: number
  }
  body: {
    name: string
    role: string
  }
}

interface IDelete {
  params: {
    id: number
  }
}

class AdminModule extends FetchFactory<any> {
  async list() {
    return await useAsyncData(() => {
      return super.call('/api/admin', {
        method: 'GET',
      })
    })
  }

  async detail(payload: IDetail) {
    const { params } = payload

    return await useAsyncData(() => {
      return super.call(`/api/admin/${params.id}`, {
        method: 'GET',
      })
    })
  }

  async store(payload: IStore) {
    const { body } = payload

    return await useAsyncData(() => {
      return super.call('/api/admin', {
        method: 'POST',
        body,
      })
    })
  }

  async update(payload: IUpdate) {
    const { params, body } = payload

    return await useAsyncData(() => {
      return super.call(`/api/admin/${params.id}`, {
        method: 'PATCH',
        body,
      })
    })
  }

  async delete(payload: IDelete) {
    const { params } = payload

    return await useAsyncData(() => {
      return super.call(`/api/admin/${params.id}`, {
        method: 'DELETE',
      })
    })
  }
}

export default AdminModule
